import { fhirClient } from 'src/App';
import { PatientEngagementService } from 'src/careflow/engagement-hub/patient-engagement/service/PatientService';

export async function getOrganizationGuardFhirResource(
  resourceType: string,
  resourceIdentifierValue: string
) {
  const response = await fhirClient.getResource(`${resourceType}/${resourceIdentifierValue}`);
  return response;
}

export enum DbGuardAllowedResources {
  PatientEngagement = 'PatientEngagement',
}

export async function getOrganizationGuardDbResource(
  resourceType: DbGuardAllowedResources,
  resourceIdentifierValue: string
) {
  let resource = null;

  switch (resourceType) {
    case DbGuardAllowedResources.PatientEngagement:
      try {
        const response = await PatientEngagementService.getOne(resourceIdentifierValue);
        return response;
      } catch (error) {
        console.log(error);
      }
      break;

    default:
      break;
  }

  return resource;
}
